<h5 mat-dialog-title i18n>Edit Template Name</h5>
<div mat-dialog-content>
  <form #printOptionsForm="ngForm" (ngSubmit)="printReport()">
    <div class="form-group">
      <input class="form-control" name="templateName" id="templateName"
             [(ngModel)]="templateName" #name="ngModel">
    </div>
    <div class="form-group float-right">
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
      <button type="button" mat-button mat-dialog-close class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>
